// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ca-logo-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto; /* Shrink wrapper to fit the image width dynamically */
    height: 45px; /* 3rem = 48px */
    margin-left: 0px; /* Align exactly with the left padding boundary of the body text */
    background: transparent;
    overflow: hidden; 
    border-radius: 0px; /* Sharp corners */
    border: none !important; /* Ensure no borders */
    box-shadow: none !important; /* Ensure no shadows */
    flex-shrink: 0; /* Prevent the logo from shrinking and cutting off */
}

.ca-logo-media {
    width: auto; /* Auto width based on aspect ratio */
    height: 100%;
    object-fit: contain; /* Fit the logo nicely */
    pointer-events: none; 
    outline: none;
    border: none;
    background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/AnimatedLogo.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW,EAAE,sDAAsD;IACnE,YAAY,EAAE,gBAAgB;IAC9B,gBAAgB,EAAE,kEAAkE;IACpF,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB,EAAE,kBAAkB;IACtC,uBAAuB,EAAE,sBAAsB;IAC/C,2BAA2B,EAAE,sBAAsB;IACnD,cAAc,EAAE,oDAAoD;AACxE;;AAEA;IACI,WAAW,EAAE,qCAAqC;IAClD,YAAY;IACZ,mBAAmB,EAAE,wBAAwB;IAC7C,oBAAoB;IACpB,aAAa;IACb,YAAY;IACZ,uBAAuB;AAC3B","sourcesContent":[".ca-logo-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto; /* Shrink wrapper to fit the image width dynamically */\n    height: 45px; /* 3rem = 48px */\n    margin-left: 0px; /* Align exactly with the left padding boundary of the body text */\n    background: transparent;\n    overflow: hidden; \n    border-radius: 0px; /* Sharp corners */\n    border: none !important; /* Ensure no borders */\n    box-shadow: none !important; /* Ensure no shadows */\n    flex-shrink: 0; /* Prevent the logo from shrinking and cutting off */\n}\n\n.ca-logo-media {\n    width: auto; /* Auto width based on aspect ratio */\n    height: 100%;\n    object-fit: contain; /* Fit the logo nicely */\n    pointer-events: none; \n    outline: none;\n    border: none;\n    background: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
